var __WEBPACK_NAMESPACE_OBJECT__ = require("formiojs/components/_classes/nested/NestedComponent.form");